__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "@signavio/workflow-main";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@signavio/mfe", "1.3.7", () => (Promise.all([__webpack_require__.e(25020), __webpack_require__.e(94547), __webpack_require__.e(86569), __webpack_require__.e(6297), __webpack_require__.e(65286)]).then(() => (() => (__webpack_require__(65286))))));
			register("@signavio/ui/core", "35.19.1", () => (Promise.all([__webpack_require__.e(20310), __webpack_require__.e(66589), __webpack_require__.e(27920), __webpack_require__.e(25020), __webpack_require__.e(35746), __webpack_require__.e(73257), __webpack_require__.e(86569)]).then(() => (() => (__webpack_require__(27920))))));
			register("@signavio/ui", "35.19.1", () => (Promise.all([__webpack_require__.e(20310), __webpack_require__.e(66589), __webpack_require__.e(90794), __webpack_require__.e(82131), __webpack_require__.e(95794), __webpack_require__.e(25020), __webpack_require__.e(35746), __webpack_require__.e(73257), __webpack_require__.e(6297)]).then(() => (() => (__webpack_require__(82131))))));
			register("react-dom", "18.3.1", () => (Promise.all([__webpack_require__.e(43144), __webpack_require__.e(25020)]).then(() => (() => (__webpack_require__(43144))))));
			register("react-router-dom", "5.3.4", () => (Promise.all([__webpack_require__.e(86090), __webpack_require__.e(25020), __webpack_require__.e(93898)]).then(() => (() => (__webpack_require__(33664))))));
			register("react-stick", "5.0.6", () => (Promise.all([__webpack_require__.e(59115), __webpack_require__.e(25020), __webpack_require__.e(35746), __webpack_require__.e(94547)]).then(() => (() => (__webpack_require__(81496))))));
			register("react", "18.3.1", () => (__webpack_require__.e(14041).then(() => (() => (__webpack_require__(14041))))));
			register("substyle", "9.4.1", () => (Promise.all([__webpack_require__.e(25020), __webpack_require__.e(31356)]).then(() => (() => (__webpack_require__(8975))))));
			initExternal(3295);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};